/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostSupplierFormInput = {|
  attachments?: ?$ReadOnlyArray<?any>,
  company: string,
  email: string,
  message?: ?string,
  name: string,
  telephone: string,
|};
export type PostSupplierFormMutationVariables = {|
  input: PostSupplierFormInput
|};
export type PostSupplierFormMutationResponse = {|
  +postSupplierForm: ?{|
    +result: ?boolean
  |}
|};
export type PostSupplierFormMutation = {|
  variables: PostSupplierFormMutationVariables,
  response: PostSupplierFormMutationResponse,
|};
*/


/*
mutation PostSupplierFormMutation(
  $input: PostSupplierFormInput!
) {
  postSupplierForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostSupplierFormPayload",
    "kind": "LinkedField",
    "name": "postSupplierForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostSupplierFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostSupplierFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd554c462ddc08cf9471e1cf34ceeb33",
    "id": null,
    "metadata": {},
    "name": "PostSupplierFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostSupplierFormMutation(\n  $input: PostSupplierFormInput!\n) {\n  postSupplierForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd0da5d1f6929ed274bd2808743f0a874';

module.exports = node;
